import type { GameState } from './types';
import { saveGameState } from './game-state';

export const MIN_PRESTIGE_TIME = 3600; // 1 hour in seconds

export function calculateWisdomGain(state: GameState): number {
  const currentRunTime = state.totalTimeWasted;
  if (currentRunTime < MIN_PRESTIGE_TIME) {
    return 0;
  }
  
  // Formula: 10 * sqrt(hours_wasted) - 9
  // Minimum of 1 point at exactly 1 hour.
  const hours = currentRunTime / 3600;
  const rawGain = Math.floor(10 * Math.sqrt(hours)) - 9;
  return Math.max(1, rawGain);
}

export function performExistentialEpiphany(state: GameState): GameState {
  const gain = calculateWisdomGain(state);
  if (gain <= 0) {
    return state; // Can't prestige yet
  }

  // Create a copy of the state
  const newState: GameState = {
    ...state,
    wisdom: state.wisdom + gain,
    epiphaniesCount: state.epiphaniesCount + 1,
    timeWasted: 0,
    totalTimeWasted: 0,
    currentRunStartTime: Date.now(),
    procrastinations: {},
    detours: {},
    // Keep wisdomUpgrades, lifetime stats, and achievements
  };

  saveGameState(newState);
  return newState;
}
